"use client";

import React from "react";
import Image from "next/image";

import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";

import { CTAButton } from "@/shadcn/ui/button";

import { PageChallengeSchema } from "@/sanity/pages/PageChallengeTemplate";

import dots from "@/public/home-v2/dots.svg";
import ChipSerif from "@/components/global/ui/ChipSerif";
import ProgressItems from "./ProgressItemsChallenge";
import { PageCompetitionAffiliateSchema } from "@/sanity/pages/PageCompetitionAffiliateTemplate";
import { PageCompetitionAffiliateV2Schema } from "@/sanity/pages/PageCompetitionAffiliateV2Template";

export default function Process({
  data,
}: {
  data: PageCompetitionAffiliateV2Schema;
}) {
  return (
    <section className="bg-[#FBFBF9]">
      <div className="w-[min(176.5rem,100%)] mx-auto rounded-[2rem] lg:rounded-[5rem] flex flex-col items-center pt-[7rem] pb-[4rem] lg:py-[12.5rem] px-[2.5rem] sm:px-[5rem] relative overflow-clip">
        <div className="w-[min(166rem,100%)] flex flex-col lg:flex-row items-center lg:items-start lg:justify-between">
          <div className="lg:sticky lg:top-[10rem] w-[min(80.875rem,100%)] flex flex-col items-start">
            <ChipSerif text={data?.processChip} className="text-white" />

            {data?.processTitle && (
              <div
                className="richtext richtext-start prose-h2:text-[4rem] lg:prose-h2:text-[7rem]  prose-h2:text-white mb-[4rem]
                lg:prose-p:w-[70.125rem] prose-p:text-white/60"
              >
                <PortableText
                  value={data.processTitle}
                  components={richTextComponent}
                />
              </div>
            )}

            <CTAButton
              className="mx-0 w-auto hidden lg:flex"
              data={data?.processCTA}
            />
          </div>

          <div className="w-[min(67.625rem,100%)]">
            <ProgressItems items={data?.processCards} />
          </div>

          <CTAButton
            className="mx-0 lg:hidden mt-[4rem] w-full"
            data={data?.processCTA}
          />
        </div>
      </div>
    </section>
  );
}
